 document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.u-tabs-button-wrapper');
  const tabContents = document.querySelectorAll('.u-img-with-text');

  // Show the first tab content by default
  if (tabContents.length > 0) {
    tabContents[0].classList.add('active');
    tabButtons[0].classList.add('active');
  }

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      // Remove active class from all buttons and content
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      // Add active class to the clicked button and corresponding content
      button.classList.add('active');
      tabContents[index].classList.add('active');
    });
  });
});initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

$(document).on('shopify:section:unload', function(event) {
  initslide();
});

function initslide() {
  $('.M-trustpilot-slider').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
 
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 575,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

var swiper = new Swiper(".umySwiper", {
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlidesBounds: true,
        
      },
      640: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.6,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3.25,
        spaceBetween: 30,
      }
    }
  });

 document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.u-tabs-button-wrapper');
  const tabContents = document.querySelectorAll('.u-img-with-text');

  // Show the first tab content by default
  if (tabContents.length > 0) {
    tabContents[0].classList.add('active');
    tabButtons[0].classList.add('active');
  }

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      // Remove active class from all buttons and content
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      // Add active class to the clicked button and corresponding content
      button.classList.add('active');
      tabContents[index].classList.add('active');
    });
  });
});
